import { init, setRouteTemplate } from "@appsignal/browser"

const body = document.querySelector("body")

const isProduction = process.env.NODE_ENV === "production"

const IGNORED_ERROR_MESSAGES = [
  /ResizeObserver/,
  /No event details available/,
  /Identifier 'originalPrompt' has already been declared/,
  /The element has no supported sources/,
  /Failed to load because no supported/,
  /hljsString/,
  /can't access dead object/,
]

const IGNORED_ERROR_SOURCES = [/-extension:\/\//, /browser extension/, /webkit-masked-url/]

// Self-reporting via the v1 browser SDK (errors + web vitals). Reports with the
// frontend key to the endpoint appsignal-server uses for its own logging
// (data-logging-endpoint, environment-driven). Requires the key to be present —
// it's only set in real deploys, so this stays inactive in dev/test/CI (feature
// specs build assets in production mode, so NODE_ENV alone isn't enough; without
// the key gate the SDK would POST with api_key=undefined and 401).
init({
  active: isProduction && Boolean(body?.dataset.appsignalFrontendKey),
  key: body?.dataset.appsignalFrontendKey,
  endpoint: "https://error-tracker.staging.lol",
  appVersion: body?.dataset.appRevision,
  tracePropagationTargets: [`${window.location.host}/**`],
  beforeError: (event) => {
    if (IGNORED_ERROR_MESSAGES.some((pattern) => pattern.test(event.message ?? ""))) {
      return null
    }
    const source = `${event.stack ?? ""}\n${event.filename ?? ""}`
    if (IGNORED_ERROR_SOURCES.some((pattern) => pattern.test(source))) {
      return null
    }
    return event
  },
})

// Rails route-template baseline (runs on every page); run.jsx refines it on SPA
// pages. Keep inline — importing the TanStack router here would patch
// history.pushState before the SDK does and break SPA navigation.
const routeTemplate = body?.dataset.appsignalRouteTemplate
if (routeTemplate) {
  setRouteTemplate(routeTemplate)
}
